import React from 'react'
import AddQuickLinks from '../../Components/QuickLinks/AddQuickLinks'

const AddQuickLinksPage = () => {
  return (
    <AddQuickLinks/>
  )
}

export default AddQuickLinksPage